import { render, staticRenderFns } from "./RamMaxVmChart.vue?vue&type=template&id=4353f172&scoped=true&"
import script from "./RamMaxVmChart.vue?vue&type=script&lang=js&"
export * from "./RamMaxVmChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353f172",
  null
  
)

export default component.exports